import { render, staticRenderFns } from "./IntelligentPay.vue?vue&type=template&id=1be73650&scoped=true"
import script from "./IntelligentPay.vue?vue&type=script&lang=js"
export * from "./IntelligentPay.vue?vue&type=script&lang=js"
import style0 from "./IntelligentPay.vue?vue&type=style&index=0&id=1be73650&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be73650",
  null
  
)

export default component.exports